import { render, staticRenderFns } from "./vue-mermaid.vue?vue&type=template&id=2d4eb5cf&"
import script from "./vue-mermaid.vue?vue&type=script&lang=js&"
export * from "./vue-mermaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports